export const apiRoutes = {
  api_r_user_authUser_getAuthUser: {
    path: 'auth-user-settings/get-auth/',
  },
  api_r_user_authUser_getAuthUser: {
    path: 'auth-user-settings/get-auth/',
  },
  api_r_user_authUser_setSidebar: {
    path: 'auth-user-settings/set-sidebar/',
  },
  api_r_user_authUser_changePassword: {
    path: 'auth-user-settings/change-password/',
  },
  api_r_user_authUser_getBreadcrumbPrepend: {
    path: 'auth-user-settings/get-breadcrumb-prepend/',
  },
  api_r_user_authUser_getModuleList: {
    path: 'auth-user-settings/get-module-list/',
  },
  api_r_user_authUser_getMapElements: {
    path: 'auth-user-settings/get-map-elements/',
  },
  api_r_user_authUser_getModuleWidgetInfo: {
    path: 'auth-user-settings/get-module-widget-info/',
  },
  api_r_user_authUser_setAuthUserTwoFactor: {
    path: 'auth-user-settings/set-auth-user-two-factor/',
  },
  api_r_user_authUser_verifyCodeAuthUserTwoFactor: {
    path: 'auth-user-settings/verify-code-auth-user-two-factor/',
  },
  api_r_user_authUser_disableCodeAuthUserTwoFactor: {
    path: 'auth-user-settings/disable-code-auth-user-two-factor/',
  },
};
